// Querys and Mutations
import {
    ALL_ACTIVE,
    CHANGE_STATUS,
    CREATE,
    UPDATE,
    GET_WITH_PAGINATION,
    DELETE
} from '@/graphql/config/HolidayGraphql'

// models
import { ResponseDefault, Paginator } from '@/models'
import { HolidayWithPagination, HolidayModel, HolidayForm } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class HolidayService {
    /**
     * Queries
     */
    async getActivated (date: string | null = ''): Promise<HolidayModel[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE,
            variables: {
                date
            }
        })
        return result.data.holidaysActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<HolidayWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.holidaysWithPagination.paginatorInfo
        const data: [HolidayModel] = result.data.holidaysWithPagination.data
        const response: HolidayWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
     async create (form: HolidayForm): Promise<HolidayModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: {
                    month: form.month,
                    day: form.day,
                    year: form.year,
                    description: form.description,
                    repeat_yearly: form.repeat_yearly,
                    is_active: form.is_active
                }
            }
        })
        return result.data.createHoliday
    }

    async update (id: number, form: HolidayForm): Promise<HolidayModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: {
                    month: form.month,
                    day: form.day,
                    year: form.year,
                    description: form.description,
                    repeat_yearly: form.repeat_yearly,
                    is_active: form.is_active
                }
            }
        })
        return result.data.updateHoliday
    }

    async changeStatus (id: number, status: boolean): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: CHANGE_STATUS,
            variables: {
                id: id,
                input: {
                    is_active: status
                }
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }
}

export default new HolidayService()
